// extracted by css-extract-rspack-plugin
export default {"Box":"column-drop-zone-sash-module__Box__izyaXij","Box_1":"column-drop-zone-sash-module__Box_1__ayVGQKw"};